export default __webpack_public_path__ + "static/media/mastercard.44616dd3.svg";